// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page-main-container-style {
    font-family: Arial, sans-serif;
  }

  .about-page-side-padding-style {
    margin-left: 100px;
    margin-right: 100px;
    margin-bottom: 100px;
    margin-top: 80px;
  }
  
  .about-section {
    text-align: center;
    width: 100%;
    margin-bottom: 40px;
  }
  
  .about-page-main-image {
    width: 95%;
    max-height: 300px;
    margin-bottom: 20px;
  }
  
  .mission-vision {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    margin-bottom: 40px;
  }
  
  .mission-vision div {
    flex: 1 1;
  }
  
  .why-choose-us {
    text-align: center;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .why-choose-icon-style {
    height: 48px;
    width: 60px;
  }
  
  .features-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }
  
  .feature {
    background: #f4f4f4;
    padding: 20px;
    border-radius: 8px;
  }

  .about-us-main-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Aligns everything to the start */
    gap: 20px; /* Adds spacing between elements */
    margin-top: 64px;
}

.about-us-container {
    text-align: center;
    max-width: 1400px;
    margin: auto;
}

.about-us-gray-text-style {
    font-size: 14px;
    font-weight: 700;
    color: #4A4A4A; /* Dark gray color */
    font-family: "Plus Jakarta Sans", sans-serif;
}

.heading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px; /* Adjust spacing between line and text */
    margin-bottom: 24px;
}

.green-line {
    width: 30px; /* Adjust width */
    height: 5px; /* Adjust thickness */
    background-color: #008D62; /* Green color */
    border-radius: 5px; /* Rounded edges */
}

.heading-text {
    font-size: 20px;
    font-weight: 600;
    color: #4A4A4A; /* Dark gray color */
    font-family: "Plus Jakarta Sans", sans-serif;
}

.about-us-section-description {
    font-size: 22px;
    font-weight: 500;
    color: #212529; /* Dark gray color */
    font-family: "Plus Jakarta Sans", sans-serif;
    text-align: left;
    margin-bottom: 42px;
    margin-top: 42px;
    margin-left: 50px;
}

.section-heading {
    font-size: 28px;
    font-weight: bold;
}

.section-description {
    font-size: 16px;
    margin-bottom: 20px;
}

.about-content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    flex-wrap: wrap;
    height: 616px;
}

.company-info {
    background: #F8F9FA;
    border-radius: 10px;
    padding: 20px;
    width: 45%;
    height: 616px;
    min-width: 300px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.company-info-title {
    font-size: 18px;
    font-weight: 700;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
    margin-bottom: 10px;
    text-align: left;
    margin-top: 52px;
}

.company-info-expertise-details-style {
    padding: 20px;
}

.company-info-expertise-seperate-details-style {
    padding: 10px; 
}

.company-info-expertise-title {
    margin-top: 42px;
    font-size: 18px;
    font-weight: 700;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
    text-align: left;
}

.company-info-sub-title-style {
    font-size: 14px;
    font-weight: 500;
    color: #6C757D;
    font-family: "Plus Jakarta Sans", serif;
    text-align: left;
    max-width: 500px;
}

.company-info-sub-title-black-text-style {
    font-size: 14px;
    font-weight: 500;
    color: #212529;
    font-family: "Plus Jakarta Sans", serif;
    text-align: left;
    max-width: 500px;
}

.image-section {
    width: 50%;
    min-width: 300px;
    gap: 20px;
}

.image-section img {
    width: 95%;
    height: 616px;
    border-radius: 10px;
}

.cta-button-main-div {
    width: 40%;
    margin-top: 32px;
    margin-bottom: 60px;
}

.cta-button {
    background-color: #212529;
    color: white;
    font-size: 16px;
    font-weight: 700;
    font-family: "Plus Jakarta Sans", serif;
    padding: 12px 24px;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    transition: background 0.3s ease-in-out;
    align-self: flex-start; /* Aligns button to the start */
}

.cta-button:hover {
    background-color: #008D62;
}
.about-page-row-content-style {
  display: flex;
  flex-direction: row; 
  width: 100%;
  gap: 40px;
  margin-left: 30px;
}

.why-choose-feature-description-style {
  font-size: 18px;
  font-weight: 700;
  font-family: "Plus Jakarta Sans", serif;
  color: #6C757D;
  max-width: 200px;
  text-align: center;
  margin-bottom: 40px;
  margin-top: 30px;
}
.why-choose-feature-title-style {
  font-size: 20px;
  font-weight: 700;
  font-family: "Plus Jakarta Sans", serif;
  color: #000000;
  text-align: center;
  margin-bottom: 48px;
}

.why-choose-us-feature-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  background-color: #F8F9FA;
  width: 100%;
}

/* .team-icon-style {
  height: 296px;
  width: 100%;
  border-top-left-radius: 20;
  border-top-right-radius: 20;
}

.team-feature-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  background-color: #F8F9FA;
  width: 100%;
}


.team-feature-title-style {
  font-size: 20px;
  font-weight: 700;
  font-family: "Plus Jakarta Sans", serif;
  color: #000000;
  text-align: center;
  margin-bottom: 10px;
  margin-top: 10px;
}

.team-feature-description-style {
  font-size: 18px;
  font-weight: 700;
  font-family: "Plus Jakarta Sans", serif;
  color: #6C757D;
  max-width: 200px;
  text-align: center;
  margin-bottom: 20px;
} */


@media (max-width: 768px) {
    .about-content {
        flex-direction: column;
        align-items: center;
    }

    .company-info, .image-section {
        width: 90%;
    }
}

  `, "",{"version":3,"sources":["webpack://./src/pages/AboutUs/about.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,mCAAmC;IAC5D,SAAS,EAAE,kCAAkC;IAC7C,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS,EAAE,yCAAyC;IACpD,mBAAmB;AACvB;;AAEA;IACI,WAAW,EAAE,iBAAiB;IAC9B,WAAW,EAAE,qBAAqB;IAClC,yBAAyB,EAAE,gBAAgB;IAC3C,kBAAkB,EAAE,kBAAkB;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAE,oBAAoB;IACpC,4CAA4C;IAC5C,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,uCAAuC;IACvC,sBAAsB,EAAE,+BAA+B;AAC3D;;AAEA;IACI,yBAAyB;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAoCG;;;AAGH;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".about-page-main-container-style {\n    font-family: Arial, sans-serif;\n  }\n\n  .about-page-side-padding-style {\n    margin-left: 100px;\n    margin-right: 100px;\n    margin-bottom: 100px;\n    margin-top: 80px;\n  }\n  \n  .about-section {\n    text-align: center;\n    width: 100%;\n    margin-bottom: 40px;\n  }\n  \n  .about-page-main-image {\n    width: 95%;\n    max-height: 300px;\n    margin-bottom: 20px;\n  }\n  \n  .mission-vision {\n    display: flex;\n    gap: 20px;\n    justify-content: space-between;\n    margin-bottom: 40px;\n  }\n  \n  .mission-vision div {\n    flex: 1;\n  }\n  \n  .why-choose-us {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .why-choose-icon-style {\n    height: 48px;\n    width: 60px;\n  }\n  \n  .features-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px;\n  }\n  \n  .feature {\n    background: #f4f4f4;\n    padding: 20px;\n    border-radius: 8px;\n  }\n\n  .about-us-main-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start; /* Aligns everything to the start */\n    gap: 20px; /* Adds spacing between elements */\n    margin-top: 64px;\n}\n\n.about-us-container {\n    text-align: center;\n    max-width: 1400px;\n    margin: auto;\n}\n\n.about-us-gray-text-style {\n    font-size: 14px;\n    font-weight: 700;\n    color: #4A4A4A; /* Dark gray color */\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\n.heading-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px; /* Adjust spacing between line and text */\n    margin-bottom: 24px;\n}\n\n.green-line {\n    width: 30px; /* Adjust width */\n    height: 5px; /* Adjust thickness */\n    background-color: #008D62; /* Green color */\n    border-radius: 5px; /* Rounded edges */\n}\n\n.heading-text {\n    font-size: 20px;\n    font-weight: 600;\n    color: #4A4A4A; /* Dark gray color */\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n}\n\n.about-us-section-description {\n    font-size: 22px;\n    font-weight: 500;\n    color: #212529; /* Dark gray color */\n    font-family: \"Plus Jakarta Sans\", sans-serif;\n    text-align: left;\n    margin-bottom: 42px;\n    margin-top: 42px;\n    margin-left: 50px;\n}\n\n.section-heading {\n    font-size: 28px;\n    font-weight: bold;\n}\n\n.section-description {\n    font-size: 16px;\n    margin-bottom: 20px;\n}\n\n.about-content {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 40px;\n    flex-wrap: wrap;\n    height: 616px;\n}\n\n.company-info {\n    background: #F8F9FA;\n    border-radius: 10px;\n    padding: 20px;\n    width: 45%;\n    height: 616px;\n    min-width: 300px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.company-info-title {\n    font-size: 18px;\n    font-weight: 700;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n    margin-bottom: 10px;\n    text-align: left;\n    margin-top: 52px;\n}\n\n.company-info-expertise-details-style {\n    padding: 20px;\n}\n\n.company-info-expertise-seperate-details-style {\n    padding: 10px; \n}\n\n.company-info-expertise-title {\n    margin-top: 42px;\n    font-size: 18px;\n    font-weight: 700;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n    text-align: left;\n}\n\n.company-info-sub-title-style {\n    font-size: 14px;\n    font-weight: 500;\n    color: #6C757D;\n    font-family: \"Plus Jakarta Sans\", serif;\n    text-align: left;\n    max-width: 500px;\n}\n\n.company-info-sub-title-black-text-style {\n    font-size: 14px;\n    font-weight: 500;\n    color: #212529;\n    font-family: \"Plus Jakarta Sans\", serif;\n    text-align: left;\n    max-width: 500px;\n}\n\n.image-section {\n    width: 50%;\n    min-width: 300px;\n    gap: 20px;\n}\n\n.image-section img {\n    width: 95%;\n    height: 616px;\n    border-radius: 10px;\n}\n\n.cta-button-main-div {\n    width: 40%;\n    margin-top: 32px;\n    margin-bottom: 60px;\n}\n\n.cta-button {\n    background-color: #212529;\n    color: white;\n    font-size: 16px;\n    font-weight: 700;\n    font-family: \"Plus Jakarta Sans\", serif;\n    padding: 12px 24px;\n    border: none;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: background 0.3s ease-in-out;\n    align-self: flex-start; /* Aligns button to the start */\n}\n\n.cta-button:hover {\n    background-color: #008D62;\n}\n.about-page-row-content-style {\n  display: flex;\n  flex-direction: row; \n  width: 100%;\n  gap: 40px;\n  margin-left: 30px;\n}\n\n.why-choose-feature-description-style {\n  font-size: 18px;\n  font-weight: 700;\n  font-family: \"Plus Jakarta Sans\", serif;\n  color: #6C757D;\n  max-width: 200px;\n  text-align: center;\n  margin-bottom: 40px;\n  margin-top: 30px;\n}\n.why-choose-feature-title-style {\n  font-size: 20px;\n  font-weight: 700;\n  font-family: \"Plus Jakarta Sans\", serif;\n  color: #000000;\n  text-align: center;\n  margin-bottom: 48px;\n}\n\n.why-choose-us-feature-view {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 30px;\n  background-color: #F8F9FA;\n  width: 100%;\n}\n\n/* .team-icon-style {\n  height: 296px;\n  width: 100%;\n  border-top-left-radius: 20;\n  border-top-right-radius: 20;\n}\n\n.team-feature-view {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 30px;\n  background-color: #F8F9FA;\n  width: 100%;\n}\n\n\n.team-feature-title-style {\n  font-size: 20px;\n  font-weight: 700;\n  font-family: \"Plus Jakarta Sans\", serif;\n  color: #000000;\n  text-align: center;\n  margin-bottom: 10px;\n  margin-top: 10px;\n}\n\n.team-feature-description-style {\n  font-size: 18px;\n  font-weight: 700;\n  font-family: \"Plus Jakarta Sans\", serif;\n  color: #6C757D;\n  max-width: 200px;\n  text-align: center;\n  margin-bottom: 20px;\n} */\n\n\n@media (max-width: 768px) {\n    .about-content {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .company-info, .image-section {\n        width: 90%;\n    }\n}\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
